import { render, staticRenderFns } from "./desvincular_factura.vue?vue&type=template&id=5b5e1b84"
import script from "./desvincular_factura.vue?vue&type=script&lang=js"
export * from "./desvincular_factura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports